<template>
  <div class="body-div">
    <div class="top-div">
      <div class="endpoint-calls">
        <button v-on:click="getDepositRegistrationReport">
          Get Deposit Registration Report
        </button>
      </div>

      <span v-for="time in report" v-bind:key="time">
        <b>Time Frame:</b>
        {{ time.id }}<br />
        *Each column in the table represents the amount in the specific hour
        throughout the whole time frame(first column is first hour and so
        on...)*<br />
        <table>
          <tr>
            <th>parameters</th>
            <th
              v-for="(frame, key) in time['clients_per_hour']"
              v-bind:key="frame"
            >
              {{ key }}
            </th>
            <th>averages</th>
          </tr>
          <tr>
            <td>Clients</td>
            <td v-for="frame in time['clients_per_hour']" v-bind:key="frame">
              {{ frame }}
            </td>
            <td>{{ time["average_clients"] }}</td>
          </tr>
          <tr>
            <td>Deposits</td>
            <td v-for="frame in time['deposits_per_hour']" v-bind:key="frame">
              {{ frame }}
            </td>
            <td>{{ time["average_deposits"] }}</td>
          </tr>
          <tr>
            <td>Unique clients</td>
            <td v-for="frame in time['uniques_per_hour']" v-bind:key="frame">
              {{ frame }}
            </td>
            <td>{{ time["average_uniques"] }}</td>
          </tr>
        </table>

        <span><b>Clients</b></span
        ><br />
        Average clients per hour:
        {{ time.average_clients_per_hour }}<br />
        Average cost per hour :
        {{ time.average_cost_per_hour }}<br />
        <span><b>Deposits</b></span
        ><br />
        Average Deposits per hour:
        {{ time.average_deposits_per_hour }}<br />
        Average profit per hour :
        {{ time.average_profit_per_hour }}<br />
        <span><b>Averages</b></span
        ><br />
        <span v-for="(avg, interval) in time['averages']" v-bind:key="avg">
          Time interval:
          {{ interval }}<br />
          <table class="data-table">
            <tr>
              <th>parameters</th>
              <th v-for="frame in avg['intervals']" v-bind:key="frame">
                {{ frame.id }}
              </th>
              <th>averages</th>
            </tr>
            <tr>
              <td>Clients</td>
              <td v-for="frame in avg['intervals']" v-bind:key="frame">
                {{ frame.clients }}
              </td>
              <td>{{ avg.average_clients }}</td>
            </tr>
            <tr>
              <td>Cost</td>
              <td v-for="frame in avg['intervals']" v-bind:key="frame">
                {{ frame.cost }}
              </td>
              <td>{{ avg.average_cost }}</td>
            </tr>
            <tr>
              <td>Deposits</td>
              <td v-for="frame in avg['intervals']" v-bind:key="frame">
                {{ frame.deposits }}
              </td>
              <td>{{ avg.average_deposits }}</td>
            </tr>
            <tr>
              <td>Profit</td>
              <td v-for="frame in avg['intervals']" v-bind:key="frame">
                {{ frame.profit }}
              </td>
              <td>{{ avg.average_profit }}</td>
            </tr>
            <tr>
              <td>Unique Clients</td>
              <td v-for="frame in avg['intervals']" v-bind:key="frame">
                {{ frame.uniques }}
              </td>
              <td>{{ avg.average_uniques }}</td>
            </tr>
            <tr>
              <td>Clients-deposit ratio</td>
              <td v-for="frame in avg['intervals']" v-bind:key="frame">
                {{ frame.client_deposit_ratio }}
              </td>
              <td>{{ avg.average_client_deposit_ratio }}</td>
            </tr>
            <tr>
              <td>Unique-deposit ratio</td>
              <td v-for="frame in avg['intervals']" v-bind:key="frame">
                {{ frame.unique_deposit_ratio }}
              </td>
              <td>{{ avg.average_unique_deposit_ratio }}</td>
            </tr>
          </table>

          <br />
        </span>
        <hr />
      </span>

      <!--      <loader class="loader" :size="'8px'" v-if="reportBusy"></loader>-->
      <div class="loader-div" v-if="reportBusy">
        <!--        <loader :size="'8px'"></loader>-->
        <span class="insteadLoader"
          >CREATING REPORT ,PLEASE WAIT
          <div class="snippet" data-title=".dot-flashing">
            <div class="stage">
              <div class="dot-flashing"></div>
            </div>
          </div>
        </span>
      </div>
    </div>
    <div class="bottom-div" v-if="false">
      <span v-if="false"
        >Forbidden, You are not authorized to see this data</span
      >
      <div class="fab"><span class="fas fa-file-csv"></span></div>
    </div>
  </div>
</template>

<script>
import Loader from "../../../../../main/misc.main/loader/Loader";
import {mapGetters, mapState} from "vuex";
import apiClientCreator from "../../../../../helpers/api/request";
export default {
  name: "RegistrationDepositReport.container",
  // components: { Loader },
  data() {
    return {
      reportBusy: false,
      report: []
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapState("clients", [ "dictionaries", "salesPersonList"])
  },
  created() {},
  methods: {
    async getDepositRegistrationReport() {
      this.report = [];
      if (
        !this.reportBusy &&
        this.checkPermissions(this.auth, [1, 2, 3, 4, 12])
      ) {
        try {
          this.reportBusy = true;
          const res = await apiClientCreator(
            "reports/deposits_registration/report/true"
          ).get("");
          this.report = res.data;
          this.reportBusy = false;
        } catch (e) {}
      }
    },
    checkPermissions(user, permitted) {
      return permitted.some(role => role === user.user.role);
    }
  }
};
</script>

<style scoped>
.body-div {
  padding: 4px 5px 1px 5px;
}
.top-div {
  width: 100%;
  height: max-content;
  margin: auto;
  background: white;
  border-radius: 3px;
  padding: 5px 5em;
}
.bottom-div {
  width: 100%;
  height: 650px;
  overflow-y: scroll;
  margin: 5px auto;
  background: white;
  border-radius: 3px;
  padding: 5px;
  position: relative;
}
.fab {
  background-color: transparent;
  padding: 0;
  font-size: 30px;
  line-height: 30px;
  color: green;
  text-align: center;
  position: absolute;
  right: 10px;
  bottom: 10px;
  border-radius: 20%;
  transition: all 0.1s ease-in-out;
  cursor: pointer;
}

.fab:hover {
  box-shadow: 0 5px 11px 0 #666;
  transform: scale(1.05);
}
table,
th,
td {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 0 1em;
}
.loader {
  left: 0;
  right: 0;
}

.endpoint-calls {
  display: flex;
  justify-content: center;
  padding: 2em 0;
}
.overall-call-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
/**
 * ==============================================
 * Dot Flashing
 * ==============================================
 */
.dot-flashing {
  position: relative;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite linear alternate;
  animation-delay: 0.5s;
}

.dot-flashing::before,
.dot-flashing::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
}

.dot-flashing::before {
  left: -15px;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 0s;
}

.dot-flashing::after {
  left: 15px;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 1s;
}

@keyframes dotFlashing {
  0% {
    background-color: red;
  }
  50%,
  100% {
    background-color: #ebe6ff;
  }
}
.stage {
  position: absolute;
  left: 110%;
  top: 48%;
}
.insteadLoader {
  color: red;
  position: absolute;
  left: 44%;
  top: 80px;
}
</style>
